import React from 'react'

export const TaskDetails = (task) => {
    console.log(task)
  return (
    <div></div>
  )
}
